import HotelStrategyDetailBaseRoute from 'lumen/routes/hotel/strategy/detail-base';
import { TYPE_ID_MOBILE } from 'lumen/utils/constants/rate-strategy-constants';

export default class HotelStrategyMobileRoute extends HotelStrategyDetailBaseRoute {
  type = TYPE_ID_MOBILE;
}
